import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { buildScopeTranslate } from "lib/I18n";

const tRetake = buildScopeTranslate("views.content.agentforce.assessments.pages.retake_modal");
const tCommon = buildScopeTranslate("views.content.agentforce.assessments.common");

const CheckItem = ({ title, text = undefined, html = undefined, testId = undefined }) => (
  <>
    <div className="slds-col slds-shrink slds-p-right_x-small slds-m-top_x-small" aria-hidden="true">
      <tds-icon
        sprite="action"
        symbol="check"
        size="x-small"
      />
    </div>
    <div className="slds-col th-agentforce-assessment__modal-list-content">
      {html ? (
        /* eslint-disable-next-line react/no-danger */
        <p
          className="slds-text-body_regular"
          data-testid={testId}
          tabIndex="0"
          dangerouslySetInnerHTML={{ __html: `<strong>${title} </strong>${html}` }}
        />
      ) : (
        <p className="slds-text-body_regular" data-testid={testId} tabIndex="0">
          <strong>{title} </strong>
          {text}
        </p>
      )}
    </div>
  </>
);

CheckItem.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  html: PropTypes.string,
  testId: PropTypes.string,
};

const RetakeAssessmentModal = ({ open, onClose, onConfirm }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const modal = modalRef.current;
    if (modal) {
      modal.addEventListener('requestclose', onClose);
      return () => {
        modal.removeEventListener('requestclose', onClose);
      };
    }
  }, [onClose]);

  return (
    <tds-modal
      ref={modalRef}
      open={open}
      size="small"
      dismissOnClickOutside={true}
      class="th-agentforce-assessment__modal">

      {/* Header */}
      <div slot="heading" className="slds-text-heading_medium" data-testid="retake-modal-heading" tabIndex="0">
        {tRetake("title")}
      </div>

      {/* Content */}
      <div slot="content">
        <div>
          <p className="slds-text-body_regular slds-m-bottom_medium" tabIndex="0">
            {tRetake("subtitle")}
          </p>

          <div className="slds-grid slds-wrap slds-grid_vertical-align-start slds-m-bottom_medium th-agentforce-assessment__modal-list">
            <CheckItem
              title={tRetake("practice_title")}
              text={tRetake("practice_text")}
              testId="retake-modal-practice"
            />
            <CheckItem
              title={tRetake("results_title")}
              text={tRetake("results_text")}
              testId="retake-modal-results"
            />
            <CheckItem
              title={tRetake("sellers_title")}
              html={tRetake("sellers_text")}
              testId="retake-modal-sellers"
            />
          </div>
        </div>
      </div>

      {/* Footer with buttons - white background, no border */}
      <div slot="footer" className="th-agentforce-assessment__modal-footer">
        <tds-button variant="neutral" onClick={onClose} data-testid="retake-modal-cancel-btn">
          <span>{tRetake("buttons.secondary")}</span>
        </tds-button>
        <tds-button variant="brand" onClick={onConfirm} data-testid="retake-modal-confirm-btn">
          <span>{tRetake("buttons.primary")}</span>
        </tds-button>
      </div>
    </tds-modal>
  );
};

RetakeAssessmentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default RetakeAssessmentModal;
